export { default } from "./DispensariesHeader";
